import React from "react";
import { IDSCard } from "@inera/ids-react";
import QuestionList from "./QuestionList";
import LinkifiedText from "../common/LinkifiedText";
import { sectionAnchorId } from "./SectionNavigator";

function SectionItem({ section, answers, onAnswerChange, validationErrors, depth = 0 }) {
  const {
    sectionId,
    sectionCode,
    sectionTitle,
    sectionDescription,
    questions = [],
    children = [],
  } = section;

  const body = (
    <>
      <h3
        className={depth === 0 ? "ids-heading-m" : "ids-heading-s"}
        style={{ marginTop: 0, marginBottom: sectionDescription ? "0.5rem" : "1rem" }}
      >
        {sectionCode} {sectionTitle}
      </h3>

      <LinkifiedText
        className="ids-text-body ids-mb-4"
        style={{
          whiteSpace: "pre-line",
          color: "var(--ids-palette-neutral-30)",
          fontSize: "0.9375rem",
        }}
      >
        {sectionDescription}
      </LinkifiedText>

      {questions.length > 0 && (
        <QuestionList
          questions={questions}
          answers={answers}
          onAnswerChange={onAnswerChange}
          validationErrors={validationErrors}
        />
      )}

      {children && children.length > 0 && (
        <div>
          {children.map((child) => (
            <SectionItem
              key={child.sectionId}
              section={child}
              answers={answers}
              onAnswerChange={onAnswerChange}
              validationErrors={validationErrors}
              depth={depth + 1}
            />
          ))}
        </div>
      )}
    </>
  );

  // Top-level sections get their own card and an anchor for the section navigator.
  if (depth === 0) {
    return (
      <IDSCard className="ids-mb-6" id={sectionAnchorId(sectionId)}>
        <div>{body}</div>
      </IDSCard>
    );
  }

  return (
    <section className="ids-mb-5" style={{ marginTop: "1.5rem" }}>
      {body}
    </section>
  );
}

export default SectionItem;
